var HeaderCover   = require("app/ui/header/Cover"),
    frameThrottle = require("enyo-perf/utils").frameThrottle,
    kind          = require("enyo/kind");

module.exports = kind(/** @lends  app.PodcastPage.HeaderCover.prototype */ {

    /**
     * @private
     */
    name: "app.PodcastPage.HeaderCover",

    /**
     * @private
     */
    kind: HeaderCover,

    /**
     * @private
     */
    classes: "app-podcast-page-header-cover",

    /**
     * @private
     */
    observers: {
        update: ["data", "formFactor"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * @method
     * @private
     */
    update: kind.inherit(function(sup) {
        return function() {
            // Play icon isn't needed
            this.$.playMediaButton.hide();

            sup.apply(this, arguments);
        };
    })
});
